import { Autocomplete, TextField } from '@mui/material';
import type { AutocompleteProps } from '@mui/material/Autocomplete/Autocomplete';
import { CRITERION_OPERATORS } from '@weft/types';
import { values } from '@weft/utils';
import React from 'react';

type CriterionSelectProps = Omit<AutocompleteProps<string, false, false, false>, 'options' | 'renderInput'>;

export const CriterionSelect: React.FC<CriterionSelectProps> = (props) => {
  return (
    <Autocomplete
      size="small"
      {...props}
      options={values(CRITERION_OPERATORS)}
      renderInput={(params) => (
        <TextField
          label="Criterion"
          placeholder="Select criterion"
          {...params}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password',
          }}
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  );
};